import shortid from "shortid";

export default [
  {
    tagName: "mj-column",
    attributes: {
      width: "100%",
      "vertical-align": "top",
    },
    children: [],
    uid: shortid.generate(),
  },
];
